const cookieValue = (name) => {
    let matches = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
    );
    return matches && matches[1] ? JSON.parse(decodeURIComponent(matches[1])) : undefined;
};

export default cookieValue;
